import "bootstrap/dist/css/bootstrap.min.css";
import "../../dist/custom.scss";
import leuwint from "../../images/leuwint.jpeg";
import "../Login/Login.css"

import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { generateOTP, validateOTP } from "../../../utilities/apis";
import { useDispatch } from "react-redux";
import { Alert } from "@mui/material";
import Slide from "@mui/material/Slide";
import { setUserID, setUserRole } from "../../../app/state/userSlice";
import Loader from "../../Loader";

function Login() {
  const [userName, setUserName] = useState("");
  const [otp, setOtp] = useState("");
  const [emailError, setEmailError] = useState("");
  const [otpError, setOtpError] = useState("");
  const [responseMessage, setResponseMessage] = useState("");
  const [showRequestAgain, setShowRequestAgain] = useState(false);
  const [disableSubmit, setDisableSubmit] = useState(true);
  const [resendOTP, setResendOTP] = useState(true);
  const [resend, setResend] = useState(false);
  const [isUserRegistered, setIsUserRegistered] = useState(false);
  const [otpValidate, setOtpValidate] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showOtpTostr, setShowOtpTostr] = useState(false);
  const [timer, setTimer] = useState(0);
  const [resendText, setResendText] = useState(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleUserName = (e) => {
    const value = e.target.value;
    setUserName(value);
    if (!value.trim()) {
      setEmailError("");
    } else if (!value.match(/^[\w-]+(?:\.[\w-]+)*@(?:[\w-]+\.)+[a-zA-Z]{2,7}$/)) {
      setEmailError("Please enter a valid email address.");
    } else {
      setEmailError("");
    }
  };

  useEffect(() => {
    console.log("Username changed:", userName);
  }, [userName]);

  useEffect(() => {
    setTimeout(() => {
      setOtpValidate(false);
      setShowOtpTostr(false);
    }, 3000);
  }, [showOtpTostr, otpValidate]);

  useEffect(() => {
    let interval;
    if (timer > 0) {
      setResend(true);
      setResendText(`Resend OTP in ${timer} seconds`);
      interval = setInterval(() => {
        setTimer(timer - 1);
      }, 1000);
    } else if (timer === 0) {
      setResend(false);
      setResendText(null);
    }
    return () => clearInterval(interval);
  }, [timer]);

  const handleOtp = (e) => {
    const value = e.target.value;
    setOtp(value);
    if (!value.trim()) {
      setOtpError("");
    } else if (!value.match(/^\d{4}$/)) {
      setOtpError("Please enter a 4-digit OTP.");
    } else {
      setOtpError("");
    }
  };

  const handleSendOTP = async () => {
    if (!userName.match(/^[\w-]+(?:\.[\w-]+)*@(?:[\w-]+\.)+[a-zA-Z]{2,7}$/)) {
      setEmailError("Please enter a valid email address.");
      return;
    }

    setIsLoading(true);
    try {
      const apiResponse = await generateOTP(userName);
      setResendOTP(false);
      setDisableSubmit(false);
      setTimer(30); // Reset timer to 30 seconds
      if (apiResponse.registered === true) {
        setIsUserRegistered(true);
      } else {
        setIsUserRegistered(false);
      }
      if (apiResponse.success === true) {
        setShowOtpTostr(true);
        setResponseMessage(apiResponse.message);
      } else {
        setResponseMessage(apiResponse.message);
        setShowRequestAgain(true);
      }
    } catch (error) {
      console.log("Unable to generate OTP: ", error);
    } finally {
      setIsLoading(false);
    }
  };

  const OTPLogin = async () => {
    const verifyOtpRes = await validateOTP(otp, userName);
    if (verifyOtpRes.success === true) {
      dispatch(setUserID(userName));
      dispatch(setUserRole(verifyOtpRes.user_role));

      //navigate user to Dashboard
      if (isUserRegistered === true) {
        navigate("/home");
      } else {
        navigate("/signup");
      }

      console.log("OTP Matched");
    } else {
      //Entered OTP is wrong
      setOtpValidate(true);
      console.log("Entered OTP is wrong");
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!userName) {
      setEmailError("Please enter a valid email address.");
      return;
    }
    if (!otp.match(/^\d{4}$/)) {
      setOtpError("Please enter a 4-digit OTP.");
      return;
    }
    try {
      await OTPLogin();
      console.log("Form submitted!");
    } catch (error) {
      console.error("Error generating OTP", error);
      alert("Error generating OTP. Enter a valid email ID");
    }
  };
  return (
    <>
      <section class='sectionh'>
        <div class='container'>
          <div class='row d-flex justify-content-center align-items-center' id='login'>
            <div className='otp_alerts'>
              <Slide in={otpValidate}>
                <Alert severity='warning'>Wrong OTP entered!</Alert>
              </Slide>
            </div>
            <div className='otp_alerts'>
              <Slide in={showOtpTostr}>
                <Alert severity='success'>{responseMessage}</Alert>
              </Slide>
            </div>
            <div class='col-md-9 col-lg-6 col-xl-5'>
              <img src={leuwint} className='img-fluid align-self-start' alt='logo' />
            </div>
            <div class='col-md-8 col-lg-6 col-xl-4 '>
              <div className='card shadow round' style={{ height: 390 }}>
                <div className='card-body py-4 px-md-4' id='logcrd'>
                  <h3 className='fw-bold ls-tight text-primary text-center'>Login</h3>

                  <form className='mt-0'>
                    <div className='row fromRow'>
                      <div className='form-outline mb-3'>
                        <div style={{ display: "flex" }}>
                          <small style={{ flex: 1, textAlign: "start", marginLeft: "10px" }} className='form-text text-muted'>
                            Email
                          </small>
                          <small style={{ flex: 1, textAlign: "end", marginLeft: "0px" }} className='form-text text-muted mt-1'>
                            {resendText}
                          </small>
                        </div>

                        <div class='input-group mt-1'>
                          <input
                            id='ig-otp'
                            type='text'
                            class='form-control form-inp shadow'
                            aria-label='Example text with button addon'
                            aria-describedby='button-addon1'
                            autoComplete='username'
                            onChange={handleUserName}
                            style={{
                              borderTopLeftRadius: "18px",
                              borderBottomLeftRadius: "18px",
                              textAlign: "start",
                            }}
                          />
                          <button class='btn btn-light btn-outline-primary form-inp-btn shadow' type='button' id='button-addon1' onClick={handleSendOTP} disabled={resend}>
                            <i class='fa-regular fa-paper-plane'></i> {resendOTP ? "OTP" : "Resend OTP"}
                          </button>
                        </div>

                        <small
                          id='emailError'
                          class='form-text text-muted'
                          style={{
                            textAlign: "left",
                            color: "red",
                          }}
                        >
                          {emailError}
                        </small>

                        <small style={{ display: "block", textAlign: "start", marginLeft: "10px" }} className='form-text text-muted mt-3'>
                          OTP
                        </small>
                        <input
                          type='password'
                          className='form-control shadow'
                          aria-describedby='passwordHelpBlock'
                          autoComplete='current-password'
                          onChange={handleOtp}
                          maxLength={4}
                          style={{
                            borderRadius: "20px",
                            textAlign: "start",
                          }}
                        />
                        <small id='otpError' class='form-text text-muted'>
                          {otpError}
                        </small>
                      </div>

                      <div className='d-flex justify-content-center'>
                        <button
                          type='button'
                          className='btn btn-primary rounded-pill p-2 mt-4 btn-sm  register'
                          onClick={handleSubmit}
                          style={{ width: "150px" }}
                          disabled={disableSubmit}
                        >
                          Log In
                        </button>
                      </div>

                      <p className='text-center mt-4'>{responseMessage}</p>

                      {showRequestAgain && (
                        <div>
                          <p className='resend text-muted mb-0' onClick={handleSendOTP}>
                            Didn't receive code? Request again
                          </p>
                        </div>
                      )}
                    </div>
                    {isLoading && <Loader></Loader>}
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Login;
